<template>
  <button @click="changeSpeed">{{ speed }}x</button>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  //---------------------------
  const store = useStore();
  //---------------------------
  const speedSteps = [1, 1.25, 1.5, 1.75, 2, 2.25, 2.5];
  //---------------------------
  //Текущее значение скорости
  const speed = computed(() => store.state.Audioplayer.speed);
  //---------------------------
  //Изменить скорость
  const changeSpeed = () => {
    const index = speedSteps.indexOf(speed.value);
    (index === -1 || index === speedSteps.length - 1) ?
      changeSpeedInStore(speedSteps[0]) :
      changeSpeedInStore(speedSteps[index + 1]);
  };
  //Занести изменения в стор
  const changeSpeedInStore = (volume) => {
    store.dispatch('Audioplayer/changeSpeed', volume);
  }
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>